import React from 'react';
//==================Redux==================//
import { useSelector } from 'react-redux';
//==================Externals==================//
import classNames from 'classnames';
//==================Styles==================//
import { makeStyles } from '@mui/styles';
import styles from './styles';
import { Portlet, PortletContent } from 'components';
import { Typography } from '@mui/material';
const useStyles = makeStyles(styles);

export default function AccountProfile() {
  //==================Variables==================//
  const classes = useStyles();
  const user = useSelector((state) => state.user.user);
  const rootClassName = classNames(classes.root);

  return (
    <Portlet className={rootClassName}>
      <PortletContent>
        <div className={classes.details}>
          <div className={classes.info}>
            <Typography variant="h2">
              {user.personal_info.firstname} {user.personal_info.lastname}
            </Typography>
            <Typography className={classes.locationText} variant="body1">
              {user.role}
            </Typography>
            <Typography className={classes.locationText} variant="body1">
              Metimur
            </Typography>
            <Typography className={classes.dateText} variant="body1">
              Metimur
            </Typography>
          </div>
        </div>
      </PortletContent>
    </Portlet>
  );
}
